import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { ActionTimeControl } from '../../ActionTimeControl/ActionTimeControl';
import { MoreVertIconContrast } from '../../../icons/MoreVertIconContrast';
import { getCurrentSendedLanding, getCurrentSendedTakeOff, getPreviewWorkTime } from '../../../selectors/sended-data';
import { Engine } from '../../../icons';
import { checkTimeIsCorrect, getTimeFormat } from '../../../service/NavPointsUtils';

export const StartEngineTime = memo(({ className, onChangeTime }) => {
    const { timeWorkBefore, value, timeWorkParking } = useSelector((state) => {
        const takeOff = getCurrentSendedTakeOff(state);
        const landing = getCurrentSendedLanding(state);
        const previewWorkTime = getPreviewWorkTime(state);

        return {
            value: takeOff.startEngineTime,
            timeWorkBefore: previewWorkTime.timeWorkBefore,
            timeWorkParking: getTimeFormat(landing.timeWorkParking),
        };
    }, shallowEqual);
    const { t: translate } = useTranslation();

    const startEngineSummary = React.useMemo(() => {
        const res = [];

        if (timeWorkParking) {
            res.push({
                title: translate('flightInfoPage.parkingTime'),
                value: timeWorkParking,
                isCorrect: checkTimeIsCorrect(timeWorkParking),
            });
        } else {
            res.push({
                title: translate('flightInfoPage.preFlightTime'),
                value: timeWorkBefore,
                isCorrect: checkTimeIsCorrect(timeWorkBefore),
            });
        }

        return res;
    }, [timeWorkBefore, timeWorkParking, translate]);

    return (
        <ActionTimeControl
            title={translate('flightInfoPage.startEngineTime')}
            buttonName={translate('flightInfoPage.startEngine')}
            state="ENTER_COMPLETED"
            iconButton={<Engine width="30" height="30" />}
            iconMenuImg={<MoreVertIconContrast isContrast={true} />}
            text={translate('flightInfoPage.startUpOn')}
            name="startEngineTime"
            value={value}
            summary={startEngineSummary}
            onChange={onChangeTime}
            className={className}
        />
    );
});
